import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { PointStoreProductFilterService } from './point-store-product-filter.service';

@Injectable({
  providedIn: 'root'
})
export class PointStoreProductOrderService {

  data: any = {
    adminOrders: null,
    groupHeaderInfo: null,
    historyOrders: null,
    originalPointStoreProductOrder: null,
    modifiedPointStoreProductOrder: null,
    sortBy: "DateOrdered",
    sortReverse: true,
    loadingTable: false,
    loadingProductsInfo: false,
    firstLoadedTime: false,
    OrderStatus: [
      { value: 1, name: "Processing", keyLocalization: 'Processing' },
      { value: 2, name: "In transit", keyLocalization: 'Intransit' },
      { value: 6, name: "Shipped", keyLocalization: 'Shipped' },
      { value: 3, name: "Ready for pick-up", keyLocalization: 'Ready_For_Pickup' },
      { value: 4, name: "Complete", keyLocalization: 'Complete' },
      { value: 5, name: "Cancelled", keyLocalization: 'Cancelled' },
    ],
    sortAdminBy: "DateOrdered",
    sortAdminReverse: true,
    pointStoreProductOrderAdminSort: [
      { value: 0, sort: null, name: 'PointStoreOrderID' },
      { value: 1, sort: null, name: 'LoginName' },
      { value: 2, sort: null, name: 'DateOrdered' },
      { value: 3, sort: null, name: 'OrderTotal' },
      { value: 4, sort: null, name: 'OrderStatus' },
      { value: 5, sort: null, name: 'Note' },
      { value: 6, sort: null, name: 'ParentGroup' }
    ],
    pointStoreProductOrderSort: [
      { value: 0, sort: null, name: 'PointStoreOrderID' },
      { value: 1, sort: null, name: 'DateOrdered' },
      { value: 2, sort: null, name: 'OrderTotal' },
      { value: 3, sort: null, name: 'OrderStatus' },
      { value: 4, sort: null, name: 'Note' }
    ],
    pointStoreProductOrdersCSS: [
      { value: 0, name: "pointStoreImage carousel-product-sale-thumbnail active" },
      { value: 1, name: "pointStoreImage carousel-product-thumbnail active" },
      { value: 2, name: "pointStoreImage carousel-thumbnail active" },
      { value: 3, name: "pointStoreImage carousel-sale-thumbnail active" },
      { value: 4, name: "pointStoreImage product-sale-thumbnail active" },
      { value: 5, name: "pointStoreImage product-thumbnail active" },
      { value: 6, name: "pointStoreImage sale-thumbnail active" },
      { value: 7, name: "pointStoreImage carousel-product-thumbnail inactive" },
      { value: 8, name: "pointStoreImage sale-thumbnail inactive" },
      { value: 9, name: "pointStoreImage sort-double-arrow-icon sortable-double-arrow" },
      { value: 10, name: "pointStoreImage sort-arrow-up-icon" },
      { value: 11, name: "pointStoreImage sort-arrow-down-icon" },
      { value: 12, name: "" }, //A default value for the sort arrows.
      { value: 13, name: "sgSelectUpArrow sgHideDownArrow" },
      { value: 14, name: "sgSelectDownArrow sgHideUpArrow" },
    ],
    pointStoreProductMessages: [
      { value: 0, name: "warning", keyLocalization: "Warning" },
      { value: 1, name: "Point Store Order Management Validation Warning", keyLocalization: "Order_Management_Validation_Warning" },
      { value: 2, name: "If you change the status to complete, you can not undo it, Continue anyway?", keyLocalization: "Change_Status_Complete" },
      { value: 3, name: "Yes", keyLocalization: "Yes" },
      { value: 4, name: "No", keyLocalization: "No" },
      { value: 5, name: "If you change the status to cancelled, you can not undo it, Continue anyway?", keyLocalization: "Change_Status_Cancelled" },
    ],
    clickEdited: false,
    pointStoreProductAdminOrderFilter: null,
    pointStoreProductAgentOrderFilter: null,
    isUpdating: false,
    isLoaded: false,
    PointStoreProductAgentOrderFilter: { searchOrder: '', } /**** you should check this one (maybe search how can you use angularJS services here) */
  }

  constructor(
    private cvLocalizationService: CVLocalizationService,
    private cvApiService: CVApiService,
    private pointStoreProductFilterService: PointStoreProductFilterService
  ) { 
    this.data.pointStoreProductAdminOrderFilter = this.pointStoreProductFilterService.getNewAdminOrderFilter();
    this.data.pointStoreProductAgentOrderFilter = this.pointStoreProductFilterService.getNewAgentOrderFilter()
  }

  async loadPointStoreProduct() {
    this.data.loadingProductsInfo = true;

    try {
      const url = "/api/v2/marketplace/admin/products/";
      let response = await this.cvApiService.get(url);

      if (response.status_code == 200) {
        this.data.loadingProductsInfo = false;
        return response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Point Store Products");
    }
  }

  async loadOrderStatusName() {
    try {
      let response = await this.cvLocalizationService.GetSection('MarketPlace_Management_Status');
      for (let i = 0; i < this.data.OrderStatus.length; i++) {
        this.data.OrderStatus[i].name = response.get(this.data.OrderStatus[i].keyLocalization);
      }
    } catch (error) {
      showErrorMessage(error.message);
    }
  }

  async LoadPointStoreProductHistoryOrders() {
    try {
      const url = "/api/v1/marketplace/orders/";
      let response = await this.cvApiService.get(url);

      if (response.status_code == 200) {
        this.data.isLoaded = true;
        this.data.historyOrders = response.data;
        this.data.isUpdating = false;
        return response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Point Store Product Order by LoginID: " + error.message);
    }
  }

  getOrderStatusName(orderStatusID) {
    for (let i = 0; i < this.data.OrderStatus.length; i++) {
      if (this.data.OrderStatus[i].value == orderStatusID) {
        return this.data.OrderStatus[i].name;
      }
    }
  };

  createOrdersAgentFilter() { }
}
